import { useAuth } from '@/contexts/AuthContext';
import { useImpersonationTarget } from '@/contexts/ImpersonationTargetContext';

const inicialesDe = (nombre: string) =>
  nombre.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p.charAt(0).toUpperCase()).join('') || 'U';

export interface PerfilVista {
  nombre: string;
  rol: string;
  iniciales: string;
  email: string;
  /** Hay "Ver como" activo: nombre y rol son de la persona impersonada. */
  impersonando: boolean;
}

/**
 * Quién se muestra en el perfil del portal (encabezado y pie del menú): con "Ver como" activo, la
 * persona impersonada (lo que ella vería); si no, el usuario de la sesión. Fuente única para no
 * pintar al admin mientras se ve como otra persona.
 */
export function usePerfilVista(fallback?: { nombre?: string | null; rol?: string | null }): PerfilVista {
  const { profile, user } = useAuth();
  const target = useImpersonationTarget();
  if (target) {
    const nombre = (target.nombre ?? '').trim() || target.email || 'Usuario';
    return { nombre, rol: target.rolNombre ?? '', iniciales: inicialesDe(nombre), email: target.email ?? '', impersonando: true };
  }
  const nombre =
    (fallback?.nombre ?? '').trim() || (profile?.nombre ?? '').trim() || user?.email || 'Usuario';
  return {
    nombre,
    rol: fallback?.rol ?? profile?.rol_nombre ?? '',
    iniciales: inicialesDe(nombre),
    email: profile?.email ?? user?.email ?? '',
    impersonando: false,
  };
}
